import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";

import {
	$loadableRemoteWorkspaceId,
	$loadableRemoteWorkspaceSlug,
} from "../../internal/document/current-document.atom";
import { $remoteWorkspace } from "../../internal/document/sharing";

export const useRemoteWorkspace = (documentId: string | undefined) => {
	const $remote = useAtomValue(loadable($remoteWorkspace(documentId)));

	return {
		exists: $remote.state === "hasData" ? $remote.data !== undefined : false,
		workspace: $remote.state === "hasData" ? $remote.data : undefined,
		isLoading: $remote.state === "loading",
		isError: $remote.state === "hasError",
		error: $remote.state === "hasError" ? $remote.error : undefined,
	};
};

export const useRemoteWorkspaceSlug = (documentId: string | undefined) => {
	const $remoteWorkspaceSlug = useAtomValue($loadableRemoteWorkspaceSlug(documentId));
	return $remoteWorkspaceSlug.state === "hasData" ? $remoteWorkspaceSlug.data : undefined;
};

export const useRemoteWorkspaceID = (documentId: string | undefined) => {
	const $remoteWorkspaceID = useAtomValue($loadableRemoteWorkspaceId(documentId));
	return $remoteWorkspaceID.state === "hasData" ? $remoteWorkspaceID.data : undefined;
};
